import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RequestThaitracesPageData, RequestThaitracesAppView} from '../../../../generated-model/models';
import {PageResponse} from '../../../shared/commons/page-response';

@Injectable({providedIn: 'root'})
export class ThaitracesReqLogService {
  private readonly http = inject(HttpClient);

  search(params: Record<string, string | number>): Observable<PageResponse<RequestThaitracesPageData>> {
    return this.http.get<PageResponse<RequestThaitracesPageData>>('/api/thaitraces-req-log', {params: params as any});
  }

  getApplicationDetails(token: string): Observable<RequestThaitracesAppView[]> {
    return this.http.get<RequestThaitracesAppView[]>(`/api/thaitraces-req-log/${encodeURIComponent(token)}/applications`);
  }
}
